export default {
    USER_ID: 'user_1snw74fQxXETt1SmDujY9',
    TEMPLATE_ID: 'template_ec7acui',
}
